import Vue from 'vue';
import Vuex from 'vuex';
import contacto from '@/store/modules/contacto';
import firma from '@/store/modules/firma';
import cliente from '@/store/modules/cliente';
import documento from '@/store/modules/documento';
import certificado from '@/store/modules/certificado';
import notificacion from '@/store/modules/notificacion';
import firmante from '@/store/modules/firmante';
import nom151 from '@/store/modules/nom151';
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
	contacto,
	firma,
	cliente,
	documento,
	notificacion,
	certificado,
	firmante,
	nom151,
  },
});
